import React from "react";
import styled from "styled-components";
import { IconSvg } from "monica-alexandria";
import { read_timeline_date_label } from "../../../utils/timeline/timeline_formatting";
import { Timeline_Sales_Session_Changes } from "./Timeline_Sales_Session_Changes";
import { Timeline_Sales_Session_Transition } from "./Timeline_Sales_Session_Transition";

const TimelineSalesCallback = styled.div`
    display: grid;
    gap: 0.25rem;
    min-width: 0;
    padding: 0.8rem 1rem;
    font-family: "fontMedium", sans-serif;

    p,
    strong,
    span,
    time {
        color: ${p => p.theme.color};
        overflow-wrap: anywhere;
        white-space: pre-wrap;
    }
`;

const TimelineSalesCallbackSchedule = styled.p`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.35rem;
    color: ${p => p.theme.color} !important;
`;

const TimelineSalesCallbackScheduleLabel = styled.strong`
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;

    svg {
        width: 1.4rem;
        height: 1.4rem;
        fill: currentColor;
    }
`;

// Displays the Stalling transition, scheduled callback and matching comment as one scenario.
export const Timeline_Sales_Session_Callback = (props) => {
    const isMeeting = `${props.event.statusChange?.to || ""}`.trim().toLowerCase() === "sass";
    const scheduleLabel = isMeeting ? props.t("Meeting") : props.t("Callback");

    return (
        <TimelineSalesCallback data-testid="timeline-sales-session-calendar">
            {!isMeeting && <Timeline_Sales_Session_Transition statusChange={props.event.statusChange} />}
            <TimelineSalesCallbackSchedule>
                <TimelineSalesCallbackScheduleLabel title={props.t("calendar")}>
                    <IconSvg Icon="Calendar" />
                    <span>{scheduleLabel}</span>
                </TimelineSalesCallbackScheduleLabel>
                <time dateTime={props.event.schedule}>{read_timeline_date_label(props.event.schedule)}</time>
            </TimelineSalesCallbackSchedule>
            {props.event.comment && <p>{props.event.comment}</p>}
            <Timeline_Sales_Session_Changes event={props.event} t={props.t} />
        </TimelineSalesCallback>
    );
};
